import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, User, LogOut } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { AuthModal } from './AuthModal';

export const Header: React.FC = () => {
    const { user, logout, isAuthModalOpen, openAuthModal, closeAuthModal } = useAuth();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const location = useLocation();

    const isActive = (path: string) => location.pathname === path;

    return (
        <>
            <header className="app-header">
                <div className="header-container">
                    <Link to="/" className="logo">
                        PolyGrid <span className="beta-badge">Beta</span>
                    </Link>

                    <nav className={`nav-links ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
                        <Link to="/" className={isActive('/') ? 'active' : ''}>
                            Convert
                        </Link>
                        <Link to="/features" className={isActive('/features') ? 'active' : ''}>
                            Features
                        </Link>
                        <Link to="/pricing" className={isActive('/pricing') ? 'active' : ''}>
                            Pricing
                        </Link>
                        <Link to="/legal" className={isActive('/legal') ? 'active' : ''}>
                            Legal
                        </Link>
                        <Link to="/contact" className={isActive('/contact') ? 'active' : ''}>
                            Contact
                        </Link>
                        {user && (
                            <Link to="/account" className={isActive('/account') ? 'active' : ''}>
                                Account
                            </Link>
                        )}
                    </nav>

                    <div className="header-actions">
                        {user ? (
                            <div className="user-menu">
                                <span className="user-email">{user.email}</span>
                                <button onClick={logout} className="icon-button" title="Sign Out">
                                    <LogOut size={20} />
                                </button>
                            </div>
                        ) : (
                            <button
                                className="button primary small"
                                onClick={openAuthModal}
                            >
                                <User size={16} style={{ marginRight: '8px' }} />
                                Sign In
                            </button>
                        )}

                        <button
                            className="mobile-menu-toggle"
                            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                        >
                            {isMobileMenuOpen ? <X /> : <Menu />}
                        </button>
                    </div>
                </div>
            </header>

            <AuthModal
                isOpen={isAuthModalOpen}
                onClose={closeAuthModal}
            />
        </>
    );
};
